/* LA SALA — el director de escena del resto de la tienda. Cuadros Splash.

   Hermano de cs-vivo.js (que solo va en la portada). Este se carga en TODAS
   las páginas y se ocupa de lo que pasa cuando ya se está mirando obra:

     1. La obra viaja de la tarjeta a su ficha (transición entre documentos).
     2. El cuadro se cuelga: la obra de la ficha entra y asienta.
     3. Las tarjetas se despegan de la pared al pasar por encima.
     4. La firma se escribe cuando entra en pantalla.
     5. El corazón late al marcar favorito.
     6. El "añadido" se dibuja de un trazo.
     7. La lupa de la ficha, para ver la trama del lienzo.
     8. La rejilla se recoloca al cambiar de columnas (FLIP).

   La regla de oro, la misma de reveal.js y cs-vivo.js: NADA de esto es
   necesario para ver la página. La clase `cs-sala` en <html> —la única
   llave del CSS— solo se pone si se puede animar. Sin ella, sin JS o con
   "reducir movimiento": la tienda de siempre, entera.

   ?vivo=si fuerza el movimiento aunque el sistema pida reducirlo, y ?vivo=no
   lo apaga. Es el mismo parámetro que usa cs-vivo.js a propósito: un solo
   interruptor para enseñar toda la tienda en marcha.
*/

(function () {
  var caja = { eventos: [] };
  window.csSala = caja;
  function apunte(que, dato) {
    caja.eventos.push({ t: Math.round(performance.now()), que: que, dato: dato });
  }

  var parametro = null;
  try {
    parametro = new URLSearchParams(window.location.search).get('vivo');
  } catch (e) {
    /* Navegador muy viejo: sin forzado, que es el lado seguro. */
  }

  var reducido =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* EL INTERRUPTOR SE RECUERDA DURANTE LA VISITA (15 sep 2026).
     Gabriel tiene «reducir movimiento» puesto en su Windows, asi que sin
     ?vivo=si no ve ni una de las animaciones que encarga. Y el parametro se
     perdia en cuanto pinchaba un enlace — justo lo que se hace al revisar la
     tienda: portada, coleccion, ficha. Ahora la eleccion dura lo que dure la
     pestana, y basta con ponerlo una vez.

     sessionStorage y no localStorage a proposito: esto es una herramienta
     para revisar, no un ajuste del visitante. Al cerrar la pestana vuelve a
     mandar lo que diga el sistema, que es lo correcto. */
  try {
    if (parametro === 'si' || parametro === 'no') {
      sessionStorage.setItem('cs-vivo', parametro);
    } else if (!parametro) {
      parametro = sessionStorage.getItem('cs-vivo');
    }
  } catch (e) {
    /* modo privado o almacenamiento bloqueado: manda la URL y ya esta */
  }

  var forzado = parametro === 'si';
  var apagado = parametro === 'no';
  var anima = !apagado && (!reducido || forzado);

  var raton =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ==================================================================
     1. La obra viaja a su ficha
     ================================================================== */

  /* El nombre tiene que ser ÚNICO en la página: si dos elementos lo llevan,
     el navegador cancela la transición entera y no avisa. Por eso siempre
     se limpia antes de poner. */
  var NOMBRE = 'cs-obra';
  var marcada = null;

  function limpiarObra() {
    if (marcada) {
      marcada.style.viewTransitionName = '';
      marcada = null;
    }
    /* Cinturón: si algo quedó marcado en otra vuelta (vuelta atrás con
       bfcache, por ejemplo), se barre igual. */
    document.querySelectorAll('[style*="view-transition-name"]').forEach(function (el) {
      if (el.style.viewTransitionName === NOMBRE) el.style.viewTransitionName = '';
    });
  }

  function marcarObra(el) {
    if (!el) return;
    limpiarObra();
    el.style.viewTransitionName = NOMBRE;
    marcada = el;
  }

  /* En la FICHA: la obra principal lleva el nombre desde el primer momento.
     Se hace aquí y no en Liquid porque hay que garantizar que lo lleve UNA
     sola imagen, y la galería pinta varias según variante y tipo de medio.

     Ojo con el momento: esto corre en el cuerpo del guion (que va `defer`,
     o sea con el DOM ya montado y ANTES del primer pintado), que es justo
     la ventana en la que el navegador toma la foto de la página nueva. Si
     se esperara a DOMContentLoaded se llegaría tarde a veces. */
  function marcarObraDeFicha() {
    var lista = document.querySelector('.product__media-list');
    if (!lista) return null;
    var primera = lista.querySelector('.product__media-item.is-active') || lista.firstElementChild;
    var img = primera && primera.querySelector('img');
    if (img) marcarObra(img);
    return img;
  }

  /* En la TARJETA: al pulsar, esa foto —y solo esa— toma el nombre. En fase
     de captura, porque tiene que estar puesto antes de que el navegador
     empiece a navegar y saque la foto de la página que se va. */
  function escucharTarjetas() {
    document.addEventListener(
      'click',
      function (e) {
        var enlace = e.target.closest && e.target.closest('a[href]');
        if (!enlace) return;
        if (enlace.href.indexOf('/products/') === -1) return;
        if (enlace.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;

        /* La foto de la tarjeta a la que pertenece el enlace. Se cubren las
           dos familias de tarjeta del tema: la de Dawn (.card-wrapper) y la
           de la casa (.cs-obra, portada y favoritos). */
        var tarjeta = enlace.closest('.card-wrapper, .cs-obra, .cs-asesor__obra-caja');
        var img = tarjeta && tarjeta.querySelector('img');
        if (img) {
          marcarObra(img);
          apuntarViaje();
          apunte('obra-marcada', enlace.getAttribute('href'));
        }
      },
      true
    );
  }

  /* Al volver atrás la página puede venir del bfcache con el nombre puesto:
     si no se limpia, la siguiente transición no arranca. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) limpiarObra();
  });

  /* ==================================================================
     2. El cuadro se cuelga
     ================================================================== */

  /* Solo si NO se ha llegado por la transición de la obra: si el cuadro
     acaba de viajar desde la tarjeta, ya ha hecho su entrada y colgarlo
     otra vez sería contar dos veces lo mismo.

     Cómo se sabe: al marcar una tarjeta (`marcarObra`) se deja una nota
     con la hora. Si al abrir la ficha la nota es de hace nada, es que se
     viene de ese clic. No se consulta ninguna API de transiciones porque
     ninguna da esa respuesta a tiempo: `pagereveal` puede dispararse antes
     de que este guion llegue a escuchar. */
  var NOTA = 'cs:sala-viaje';

  function apuntarViaje() {
    try {
      window.sessionStorage.setItem(NOTA, String(Date.now()));
    } catch (e) {
      /* Sin almacén: se colgará el cuadro. Es el lado bonito del fallo. */
    }
  }

  function vinoVolando() {
    try {
      var t = parseInt(window.sessionStorage.getItem(NOTA), 10);
      window.sessionStorage.removeItem(NOTA);
      /* Margen corto: solo cuenta como viaje si el clic fue justo antes.
         Una nota vieja significa que se llegó por otro camino. */
      return !!t && Date.now() - t < 4000;
    } catch (e) {
      return false;
    }
  }

  function colgarElCuadro(img) {
    if (!img) return;
    if (vinoVolando()) {
      apunte('no-cuelga', 'vino volando');
      return;
    }
    var caja = img.closest('.product__media-item') || img;
    caja.classList.add('cs-sala-cuelga');
  }

  /* ==================================================================
     3. Las tarjetas se despegan de la pared
     ================================================================== */

  /* Un grado y cuarto: la mitad que el mosaico de la portada, que es el
     gesto grande de la casa y no debe repetirse aquí a la misma fuerza.
     Los oyentes se enganchan al entrar el ratón y se sueltan al salir, así
     que no hay 24 `mousemove` vivos a la vez en una colección. */
  function despegarTarjetas() {
    if (!raton) return;
    var MAX = 1.25;

    document.addEventListener(
      'mouseover',
      function (e) {
        var tarjeta = e.target.closest && e.target.closest('.card-wrapper');
        if (!tarjeta || tarjeta.dataset.salaPuesta) return;
        tarjeta.dataset.salaPuesta = '1';

        var pendiente = false;
        var ultimo = null;

        /* CON INERCIA SI HAY GSAP (15 sep 2026).
           El inclinado se escribía directo en cada fotograma, así que la
           tarjeta iba clavada al ratón: exacto, pero seco — y esta casa
           quiere el movimiento lento. Con GSAP delante, el mismo número
           pasa por `quickTo` y la tarjeta PERSIGUE al puntero con retardo,
           igual que las capas del hero en hero-profundidad.js.

           Lo que cambia son las VARIABLES `--sala-rx` / `--sala-ry`, no el
           `transform`. Es a propósito: el transform de la tarjeta lo compone
           cs-sala.css a partir de esas dos variables, y si GSAP escribiera
           el transform entero se llevaría por delante la perspectiva.

           > POR QUÉ HAY UN OBJETO EN MEDIO Y NO SE ANIMA LA VARIABLE.
           > El primer intento fue `gsap.quickTo(tarjeta, '--sala-rx')`, que
           > es lo que uno escribiría. **No funciona**: se probó en el
           > navegador y la variable no se movía del sitio — quickTo trabaja
           > con números pelados y estas variables necesitan grados, así que
           > la tarjeta se habría quedado sin inclinarse, en silencio.
           > Por eso GSAP anima un objeto corriente y es `onUpdate` quien
           > escribe las dos variables con su `deg` detrás.

           Sin GSAP no se pierde nada: se escribe como toda la vida. */
        var suave = null;
        if (window.gsap) {
          var estado = { rx: 0, ry: 0 };
          var pinta = function () {
            tarjeta.style.setProperty('--sala-rx', estado.rx.toFixed(2) + 'deg');
            tarjeta.style.setProperty('--sala-ry', estado.ry.toFixed(2) + 'deg');
          };
          var comun = { duration: 0.9, ease: 'power3.out', onUpdate: pinta };
          suave = {
            rx: gsap.quickTo(estado, 'rx', comun),
            ry: gsap.quickTo(estado, 'ry', comun)
          };
        }

        function apunta(rx, ry) {
          if (suave) {
            suave.rx(rx);
            suave.ry(ry);
          } else {
            tarjeta.style.setProperty('--sala-rx', rx.toFixed(2) + 'deg');
            tarjeta.style.setProperty('--sala-ry', ry.toFixed(2) + 'deg');
          }
        }

        function seguir(ev) {
          ultimo = ev;
          if (pendiente) return;
          pendiente = true;
          requestAnimationFrame(function () {
            pendiente = false;
            if (!ultimo) return;
            var r = tarjeta.getBoundingClientRect();
            var x = (ultimo.clientX - r.left) / r.width - 0.5;
            var y = (ultimo.clientY - r.top) / r.height - 0.5;
            apunta(-y * MAX, x * MAX);
          });
        }

        function soltar() {
          tarjeta.removeEventListener('mousemove', seguir);
          tarjeta.removeEventListener('mouseleave', soltar);
          delete tarjeta.dataset.salaPuesta;
          ultimo = null;
          /* Vuelve a plano por el mismo camino: con inercia si la hubo, de
             golpe si no. Si se pusiera siempre a cero a pelo, la tarjeta
             daría un tirón justo al sacar el ratón. */
          apunta(0, 0);
        }

        tarjeta.addEventListener('mousemove', seguir);
        tarjeta.addEventListener('mouseleave', soltar);
      },
      true
    );
  }

  /* ==================================================================
     4. La firma se escribe (y, desde el 21 sep 2026, cualquier frase que
        pida el mismo barrido — la de la cabecera de colección incluida)
     ================================================================== */

  /* Parisienne es tipografía, no trazado: no se le puede animar el stroke.
     Se resuelve con una máscara que barre (ver cs-sala.css). Aquí solo se
     decide CUÁNDO, y con la red de rescate de siempre.
     [data-cs-escribe] no es una firma — es la descripción de la colección,
     movida al hueco de la derecha— pero el mecanismo (máscara + observador)
     es exactamente el mismo, así que reutiliza esta misma lista en vez de
     duplicar la función entera para una frase distinta. */
  var FIRMAS = ['.cs-firma__texto', '.cs-asesor__firma', '[data-cs-firma]', '[data-cs-escribe]'];

  function escribirFirmas() {
    var firmas = document.querySelectorAll(FIRMAS.join(','));
    if (!firmas.length) return;

    firmas.forEach(function (f) {
      if (f.dataset.salaFirma) return;
      f.dataset.salaFirma = '1';
      f.classList.add('cs-sala-escribe');
    });

    var escribir = function (f) {
      f.classList.add('es-escrita');
    };

    if (!('IntersectionObserver' in window)) {
      firmas.forEach(escribir);
      return;
    }

    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          escribir(en.target);
        });
      },
      /* Umbral bajo a propósito: una firma es ancha y baja, y con 0,6 una
         que asome por el borde no llegaría a dispararse nunca. */
      { threshold: 0.35 }
    );

    firmas.forEach(function (f) {
      io.observe(f);
    });

    /* Rescate: pase lo que pase con el observador, a los 6 s está escrita.
       Una firma a medias sería peor que ninguna. */
    setTimeout(function () {
      firmas.forEach(escribir);
    }, 6000);
  }

  /* ==================================================================
     5. El corazón late
     ================================================================== */

  /* No hace falta tocar favoritos.js: ya publica `cs:favoritos-cambio` con
     el handle y si ha quedado marcado. Al desmarcar NO late — quitar algo
     no se celebra. */
  function latirFavoritos() {
    document.addEventListener('cs:favoritos-cambio', function (e) {
      var d = e.detail || {};
      if (!d.favorito) return;

      document
        .querySelectorAll('[data-cs-fav="' + CSS.escape(d.handle) + '"]')
        .forEach(function (btn) {
          btn.classList.remove('es-latido');
          /* Reiniciar la animación: leer offsetWidth fuerza el reflujo que
             hace que el navegador la vuelva a lanzar desde cero. */
          void btn.offsetWidth;
          btn.classList.add('es-latido');
        });

      var burbuja = document.getElementById('favoritos-count-bubble');
      if (burbuja) {
        burbuja.classList.remove('es-latido');
        void burbuja.offsetWidth;
        burbuja.classList.add('es-latido');
      }
    });

    document.addEventListener(
      'animationend',
      function (e) {
        if (e.target.classList && e.target.classList.contains('es-latido')) {
          e.target.classList.remove('es-latido');
        }
      },
      true
    );
  }

  /* ==================================================================
     6. El "añadido" con trazo
     ================================================================== */

  /* El check se DIBUJA con stroke-dashoffset, como quien firma un albarán.
     Se engancha al evento que ya publica el tema (pubsub.js + constants.js),
     no a la respuesta de red: así vale igual para el formulario de la ficha
     y para cualquier otra vía que publique lo mismo. */
  var ultimoBoton = null;

  function trazarAnadido() {
    document.addEventListener(
      'click',
      function (e) {
        var b = e.target.closest && e.target.closest('.product-form__submit');
        if (b) ultimoBoton = b;
      },
      true
    );

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      apunte('sin-pubsub', 1);
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      var b = ultimoBoton;
      ultimoBoton = null;
      if (!b || !b.isConnected || b.querySelector('.cs-sala-check')) return;

      var capa = document.createElement('span');
      capa.className = 'cs-sala-check';
      capa.setAttribute('aria-hidden', 'true');
      capa.innerHTML =
        '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 12.5 L9.5 18 L20 6"/></svg>';
      b.appendChild(capa);

      setTimeout(function () {
        if (capa.parentNode) capa.parentNode.removeChild(capa);
      }, 1500);
    });
  }

  /* ==================================================================
     7. La lupa de la ficha
     ================================================================== */

  /* Amplía por donde está el ratón para ver la trama del lienzo y el
     relieve del gel. Convive con la caja de luz que ya trae el tema: esto
     es al pasar por encima, aquello al pulsar.

     Solo con ratón fino. En táctil el gesto natural es el zoom del sistema
     y no hay puntero al que seguir. */
  function ponerLupa(img) {
    if (!raton || !img) return;
    var caja = img.parentElement;
    if (!caja || caja.dataset.salaLupa) return;
    caja.dataset.salaLupa = '1';
    caja.classList.add('cs-sala-lupa');

    var pendiente = false;
    var ultimo = null;

    caja.addEventListener('mouseenter', function () {
      caja.classList.add('es-lupa');
    });

    caja.addEventListener('mousemove', function (ev) {
      ultimo = ev;
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        if (!ultimo) return;
        var r = caja.getBoundingClientRect();
        var x = ((ultimo.clientX - r.left) / r.width) * 100;
        var y = ((ultimo.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin =
          Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
      });
    });

    caja.addEventListener('mouseleave', function () {
      caja.classList.remove('es-lupa');
      ultimo = null;
    });
  }

  /* ==================================================================
     8. La rejilla se recoloca (FLIP)
     ================================================================== */

  /* First-Last-Invert-Play: se mide dónde está cada tarjeta, se aplica el
     cambio, se mide dónde ha quedado y se la manda de vuelta al sitio de
     antes para dejarla viajar sola. Así el cambio de 2/3/4 columnas se ve
     como una recolocación de sala y no como un salto.

     Lo llama view-switch.js si esta API existe; si no, cambia sin más. */
  function recolocar(contenedor, cambiar) {
    if (!anima || !contenedor || typeof contenedor.animate !== 'function') {
      cambiar();
      return;
    }

    var piezas = Array.prototype.slice.call(contenedor.children);
    var antes = piezas.map(function (p) {
      return p.getBoundingClientRect();
    });

    cambiar();

    contenedor.classList.add('cs-sala-recolocando');

    var enMarcha = [];

    piezas.forEach(function (p, i) {
      var d = p.getBoundingClientRect();
      var dx = antes[i].left - d.left;
      var dy = antes[i].top - d.top;
      var ex = antes[i].width / (d.width || 1);
      if (!dx && !dy && Math.abs(ex - 1) < 0.01) return;

      enMarcha.push(
        p.animate(
          [
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + ex + ')', opacity: 0.75 },
            { transform: 'none', opacity: 1 },
          ],
          {
            duration: 620,
            easing: 'cubic-bezier(0.33, 0.04, 0.26, 1)',
            /* Escalonado corto por posición: la sala se recoloca en ola, no
               de golpe. Tope a 8 para que la última no llegue tarde. */
            delay: Math.min(i, 8) * 26,
          }
        )
      );
    });

    /* RED DE SEGURIDAD. Una animación de la Web Animations API puede quedarse
       EN ESPERA de su primer fotograma si el navegador no está pintando (una
       pestaña de fondo, por ejemplo) — y mientras espera, aplica igualmente
       su primer fotograma: la tarjeta se quedaría al 75 % y escalada, que es
       justo lo que este proyecto no permite. Pasado el tiempo de sobra, lo
       que no haya avanzado se cancela y la tarjeta vuelve a su estado normal.

       Se cancela solo lo que sigue clavado en 0: lo que va bien, ni se toca. */
    setTimeout(function () {
      contenedor.classList.remove('cs-sala-recolocando');
      enMarcha.forEach(function (a) {
        try {
          if (a.playState !== 'finished' && !a.currentTime) a.cancel();
        } catch (e) {
          /* Si ni cancelar se puede, `fill` por defecto es `none`: al menos
             no queda nada fijado al terminar. */
        }
      });
    }, 1100);
  }

  caja.recolocar = recolocar;

  /* ==================================================================
     9. Obras que conversan
     ==================================================================

     No hay nada que hacer aquí, y es una decisión: el comentario largo con
     el porqué —y con la corrección honesta del diagnóstico, que al principio
     estuvo mal— está en cs-sala.css, bajo "Obras que conversan".
     La clase `cs-sala-conversan` del marcado se conserva como asidero por
     si algún día se retoma. */

  /* ==================================================================
     Arranque
     ================================================================== */

  /* Esto va FUERA del `if (anima)`: la obra de la ficha tiene que quedar
     marcada aunque no animemos nada más, y hay que hacerlo ya —el guion es
     `defer`, o sea DOM montado y antes del primer pintado, que es la
     ventana en la que el navegador saca la foto de la página. */
  var obraDeFicha = marcarObraDeFicha();

  if (!anima) {
    apunte('sin-movimiento', { reducido: reducido, apagado: apagado });
  } else {
    document.documentElement.classList.add('cs-sala');
    if (forzado) document.documentElement.classList.add('cs-sala-forzada');

    escucharTarjetas();
    colgarElCuadro(obraDeFicha);
    despegarTarjetas();
    latirFavoritos();
    trazarAnadido();
    ponerLupa(obraDeFicha);
  }

  function iniciar() {
    if (anima) escribirFirmas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* El editor de temas reinyecta secciones sin recargar: mismo enganche que
     favoritos.js y canvas-3d.js. */
  document.addEventListener('shopify:section:load', iniciar);
})();
